import { NetworkId } from 'modules/network';
import { ProductId, ProgramId } from 'modules/program';
import { Tracking, Trackings } from 'modules/tracking';

type TGetTrackingOptions = {
  productId: ProductId;
  programId: ProgramId;
  networkId?: NetworkId;
};

function getTracking({ productId, programId, networkId }: TGetTrackingOptions): Tracking {
  const productTrackings = Trackings[productId];
  if (!productTrackings) {
    return undefined;
  }

  const programTrackings = productTrackings[programId];
  if (!programTrackings) {
    return undefined;
  }

  return programTrackings[networkId];
}

type TGetTrackingUrlOptions = {
  destination?: string;
  tracking: Tracking;
};

function getTrackingUrl({ tracking, destination }: TGetTrackingUrlOptions): string {
  const { baseUrl, camRef, pubRef, adRef, creativeRef } = tracking;

  if (baseUrl && camRef) {
    const camRefPath = `/camref:${camRef}`;
    const pubRefPath = pubRef ? `/pubref:${pubRef}` : '';
    const adRefPath = adRef ? `/adref:${adRef}` : '';
    const creativeRefPath = creativeRef ? `/creativeref:${creativeRef}` : '';
    const destinationPath = destination ? `/destination:${destination}` : '';

    return `${baseUrl}${camRefPath}${pubRefPath}${adRefPath}${creativeRefPath}${destinationPath}`;
  }

  return undefined;
}

export { getTracking, getTrackingUrl };
